export function isUpdateChannelAccessInfo(info) {
    return 'disabled' in info && !('updatedChannelName' in info || 'updatedRoleIds' in info);
}
export function isMentionedTextMessageOptions(options) {
    return 'mentions' in options && Array.isArray(options.mentions) && options.mentions.length > 0;
}
export function isThreadIdOptions(options) {
    return 'threadId' in options && typeof options.threadId === 'string';
}
//# sourceMappingURL=towns-types.js.map